import React from "react";

function CguPage() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.5",
  };

  const headingStyle = {
    marginTop: "2rem",
    marginBottom: "1rem",
    fontSize: "1.3rem",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h1>Conditions Générales d’Utilisation</h1>

      {/* 1. PREAMBULE */}
      <h2 style={headingStyle}>1. PRÉAMBULE</h2>
      <p>
        Les présentes conditions d’utilisation sont conclues entre tout internaute naviguant
        (ci-après dénommé « Internaute »), ou ayant accès aux Fonctionnalités du site{" "}
        <strong>www.BALTEE.fr</strong> (ci-après le « Site » ou la « Marketplace ») et BALTEE.
      </p>
      <p>
        Le Site est édité et exploité par la société <strong>BALTEE France</strong>, société à
        actions simplifiée, immatriculée au RCS de Rennes sous le numéro 913 340 691 et dont le
        siège social est situé PLACE DU GRANIER, 35135 CHANTEPIE.
      </p>
      <p>
        Aux fins des présentes, le <strong>Client</strong> est une personne physique agissant pour
        son propre compte ou pour le compte d’une personne morale, ou physique majeure effectuant un
        achat sur le Site en sa qualité de consommateur.
      </p>
      <p>
        L’<strong>Utilisateur</strong> est défini comme le marchand professionnel indépendant ayant
        souscrit au service de la Marketplace.
      </p>
      <p>
        L’<strong>Internaute</strong> est défini comme étant indifféremment un <em>Client</em> ou
        un <em>Utilisateur</em>.
      </p>
      <p>
        Le(s) Produit(s) proposé(s) sur le Site vise(nt) à favoriser l’information et la sécurité
        des personnes et ne supplée(nt) en aucun cas les responsabilités civiles et personnelles du
        Client.
      </p>
      <p>
        L’utilisation du Site implique impérativement l’acceptation des présentes CGU par
        l’Internaute sans réserve. Les présentes CGU sont consultables à tout moment sur le Site et
        figurent en bas de page. La version des CGU applicables est celle en vigueur au jour de la
        navigation sur la Marketplace.
      </p>

      {/* 2. FONCTIONNALITES DU SITE ET ROLE DE BALTEE */}
      <h2 style={headingStyle}>2. FONCTIONNALITÉS DU SITE ET RÔLE DE BALTEE</h2>

      <h3>1. Fonctionnalités du Site</h3>
      <p>
        À partir du Site, l’Internaute peut notamment&nbsp;:
        <ul>
          <li>Découvrir le(s) Matériel(s) proposé(s) par la société BALTEE&nbsp;;</li>
          <li>
            Effectuer des achats selon les modalités prévues par les Conditions Générales de Vente
            consultables sur le Site&nbsp;;
          </li>
          <li>Publier des avis sur l’article vendu sur le Site (après achat ou utilisation).</li>
        </ul>
      </p>

      <h3>2. Le rôle de BALTEE</h3>
      <p>
        BALTEE a un rôle de vendeur.  
        Le site <strong>www.balteemobility.com</strong> est le site marchand par lequel BALTEE vend
        le produit.
      </p>
      <p>BALTEE est le vendeur et le cocontractant direct du Client.</p>
      <p>
        BALTEE recourt à des sous-traitants pour certaines prestations telles que la livraison des
        Matériels éventuellement achetés par les Clients. Le recours à des sociétés partenaires
        tierces sera expressément mentionné et il appartiendra au Client de valider les conditions
        contractuelles d’intervention desdits partenaires sans que BALTEE ne puisse être inquiété.
      </p>

      {/* 3. ACCES AU SITE ET AUX FONCTIONNALITES */}
      <h2 style={headingStyle}>3. ACCÈS AU SITE ET AUX FONCTIONNALITÉS</h2>
      <p>
        L’Accès au Site est gratuit pour tout Internaute. Ainsi tout Internaute peut gratuitement
        consulter le produit référencé sur le Site.
      </p>

      <h3>1. Le compte client BALTEE</h3>
      <p>
        La création du compte est gratuite pour le Client et/ou l’Utilisateur. Ce dernier s’engage à
        fournir à BALTEE des données exactes et à jour. Le Client et/ou l’Utilisateur ne peut créer
        qu’un seul compte Client sur le Site.
      </p>
      <p>
        Le compte Client est personnel. Dès lors, le Client et/ou l’Utilisateur est responsable de
        toute action réalisée à partir de son compte. Il est de la responsabilité exclusive du
        Client et/ou de l’Utilisateur d’avertir le service clients de BALTEE s’il remarque une
        utilisation suspecte ou frauduleuse de son compte. BALTEE n’a pas la possibilité de vérifier
        l’identité des personnes ayant accès au Site et au compte du Client.
      </p>
      <p>
        Par conséquent, BALTEE décline toute responsabilité quant à une utilisation irrégulière (par
        exemple, personne irresponsable) ou frauduleuse du compte client par un tiers.
      </p>

      <h3>2. Suppression du compte client BALTEE</h3>
      <p>
        BALTEE se réserve le droit de supprimer définitivement ou de bloquer momentanément le
        compte du Client et/ou de l’Utilisateur en cas de non-respect des présentes Conditions ou
        des Conditions générales de vente ou de violation de la rubrique « Compte client ».
      </p>
      <p>
        Le Client et/ou l’Utilisateur reconnaît qu’en cas de suppression de son compte pour quelque
        cause que ce soit, il n’aura plus accès à l’intégralité des fonctionnalités du Site et
        notamment à la possibilité de commander les Produits ou d’avoir accès à son historique
        d’achats.
      </p>

      {/* 4. PAIEMENT */}
      <h2 style={headingStyle}>4. PAIEMENT</h2>
      <p>
        Le paiement des commandes se fait directement via le Site par l’intervention du prestataire
        de paiement <strong>Stripe</strong>. L’acceptation des conditions d’utilisation consultables
        sur <a href="https://www.stripe.fr">www.stripe.fr</a> est donc une condition nécessaire à la
        finalisation d’un compte client.
      </p>

      {/* 5. DONNEES A CARACTERE PERSONNEL */}
      <h2 style={headingStyle}>5. DONNÉES À CARACTÈRE PERSONNEL</h2>
      <p>
        Au titre de l’exploitation de la Marketplace et de la gestion des commandes, BALTEE peut
        collecter et traiter les données à caractère personnel des Internautes nécessaires à
        l’exploitation du Site. Ces données sont traitées par BALTEE et conservées pour une durée
        maximale de deux années après l’ultime activité constatée sur le compte client de
        l’Internaute.
      </p>
      <p>
        En créant un compte client, l’Internaute autorise également BALTEE à procéder à des
        traitements de données via l’âge, le code postal, la civilité et tout renseignement
        différenciant susceptible d’être exploitable à des fins commerciales.
      </p>
      <p>
        Enfin, BALTEE utilise des cookies et traceurs sur le site <strong>www.BALTEE.fr</strong>,
        ce que l’Internaute reconnaît et accepte sans restriction.
      </p>
      <p>
        Le délégué à la protection des données personnelles au sein de BALTEE peut être contacté par
        mail à l’adresse <em>contact@baltee.com</em>.
      </p>

      {/* 6. PROPRIETE INTELLECTUELLE */}
      <h2 style={headingStyle}>6. PROPRIÉTÉ INTELLECTUELLE</h2>
      <p>
        L’ensemble des Contenus (textes, commentaires, fichiers, images, photos, vidéos, œuvres,
        etc.) sont soumis à des droits de propriété intellectuelle et/ou industrielle et/ou
        artistique, des droits à l’image. Ces droits restent la propriété exclusive de BALTEE ou de
        ses partenaires.
      </p>
      <p>
        Les Clients et/ou Utilisateurs sont libres de publier ou non des commentaires sur le Site.
        Le cas échéant, ils acceptent que ces contenus deviennent publics et librement accessibles
        (par exemple sur Internet).
      </p>
      <p>
        En postant un avis ou commentaire sur le « Service Avis BALTEE », le Client et/ou
        l’Utilisateur reconnaît que cet avis devienne public et accorde à BALTEE le droit
        d’exploiter ledit contenu (publication, traduction, distribution…), de manière mondiale et
        pour une durée de 10 ans.
      </p>

      {/* 7. COMPORTEMENT SUR LE SITE */}
      <h2 style={headingStyle}>7. COMPORTEMENT SUR LE SITE</h2>
      <p>
        En naviguant et en utilisant les services du Site, l’Internaute s’interdit notamment de :
      </p>
      <ul>
        <li>Commettre un quelconque agissement illégal ;</li>
        <li>Extraire ou collecter des données personnelles du Site par un moyen quelconque ;</li>
        <li>Stocker, diffuser ou publier tout contenu illégal, injurieux ou préjudiciable ;</li>
        <li>
          Stocker, diffuser ou publier toute information permettant de révéler, directement ou
          indirectement, ses opinions politiques, philosophiques ou religieuses, son appartenance
          syndicale, son état de santé ou son orientation sexuelle ;
        </li>
        <li>Déposer des contenus pour le compte d’un tiers ;</li>
        <li>Usurper l’identité d’un tiers ou publier toute information personnelle d’un tiers ;</li>
        <li>
          Stocker, diffuser ou publier tout contenu pouvant porter atteinte aux intérêts de BALTEE
          ou de ses partenaires.
        </li>
      </ul>

      {/* 8. RESPONSABILITE */}
      <h2 style={headingStyle}>8. RESPONSABILITÉ</h2>
      <p>
        L’Internaute est informé que BALTEE peut être amené à interrompre momentanément l’accès au
        Site pour des raisons techniques (maintenance…). L’Internaute accepte ces interruptions et
        renonce à toute réclamation à ce sujet.
      </p>
      <p>
        L’utilisation du Site implique la connaissance et l’acceptation des caractéristiques et
        limites de la technologie Internet (temps de réponse, performances techniques, interruption,
        virus…).
      </p>
      <p>Par conséquent, BALTEE ne saurait en aucune circonstance être tenue responsable :</p>
      <ul>
        <li>De toute information consultée sur le Site qui ne serait pas mise en ligne par BALTEE ;</li>
        <li>De tout dysfonctionnement du réseau empêchant le bon fonctionnement du Site ;</li>
        <li>De la perte de toute donnée ;</li>
        <li>Du dysfonctionnement de tout logiciel ;</li>
        <li>Des conséquences de tout virus informatique, bug, anomalie ou défaillance ;</li>
        <li>De tout dommage causé à l’ordinateur de l’Internaute.</li>
      </ul>

      {/* 9. SERVICE CLIENT */}
      <h2 style={headingStyle}>9. SERVICE CLIENT</h2>
      <p>
        En cas de demande ou de réclamation relative au Site, l’Internaute peut contacter le service
        client BALTEE via le formulaire de contact ou via l’adresse mail :{" "}
        <strong>SAV@baltee.com</strong>.
      </p>

      {/* 10. MODIFICATION DES CGU */}
      <h2 style={headingStyle}>10. MODIFICATIONS DES CGU</h2>
      <p>
        BALTEE se réserve le droit de modifier à tout moment les présentes Conditions Générales
        d’Utilisation.
      </p>

      {/* 11. RECLAMATION, REGLEMENT DES LITIGES ET DROIT APPLICABLE */}
      <h2 style={headingStyle}>
        11. RÉCLAMATION, RÈGLEMENT DES LITIGES ET DROIT APPLICABLE
      </h2>
      <p>
        Les relations entre BALTEE et les Internautes sont régies par le droit français.  
        En cas de litige, l’Internaute devra soumettre, avant tout recours judiciaire, sa réclamation
        au service client. À défaut de réponse ou de règlement amiable sous 20 jours ouvrés,
        l’Internaute pourra saisir la juridiction compétente.
      </p>
      <p>
        En cas de litige avec un <em>Utilisateur</em>, la juridiction compétente sera le Tribunal de
        commerce de Rennes.
      </p>
    </div>
  );
}

export default CguPage;
